import { BOUTIQUE_BRAND_COLORS, CORPORATE_NAVIGATION_COLOR } from './boutiqueBrandColors';
import { BOUTIQUE_RECORDS } from '../generated/boutique_registry.generated';

export const TOTO_COLLAR_ROOT = '/brand/toto-collar-v2';

// Resolve identity from the authenticated profile, never appearance preferences.
// Match Profile: the employee directory assignment is the displayed identity.
// Corporate / unassigned profiles use Rainbow rather than an arbitrary boutique.
export function totoCollarCode(user) {
  const profile = { ...user, ...(user?.employee_profile || {}) };
  for (const field of ['boutique_code', 'boutique_id', 'boutique_name', 'boutique']) {
    const value = profile?.[field];
    if (typeof value !== 'string' || !value.trim()) continue;
    const key = value.trim().toLowerCase();
    const record = BOUTIQUE_RECORDS.find(item =>
      [item.code, item.id, item.name, item.shortName].some(alias => alias?.toLowerCase() === key));
    return record?.code || 'RBW';
  }
  return 'RBW';
}

export function totoCollarSrc(user) {
  return `${TOTO_COLLAR_ROOT}/${totoCollarCode(user).toLowerCase()}/navigation.webp`;
}

export function totoCollarNavigationColor(user) {
  return BOUTIQUE_BRAND_COLORS[totoCollarCode(user)] || CORPORATE_NAVIGATION_COLOR;
}
